module.exports = __webpack_public_path__ + "img/icon_chexiao.3d915839.svg";